import { toPointExpirySummaryModel } from 'core/profile'
import { SmartClub } from 'tokyu-hooks'

export const QUERY_POINT_EXPIRING_SUMMARY_KEY =
  'QUERY_POINT_EXPIRING_SUMMARY_KEY'

export const fetchPointExpiringSummary =
  (smartClubId?: number, accessToken?: string) => async () => {
    if (!accessToken || !smartClubId) return null

    const res = await SmartClub.getPointExpiringSummary({
      baseUrl: process.env.NEXT_PUBLIC_SMART_CLUB_URL as string,
      smartClubId: smartClubId,
      accessToken,
    })

    return toPointExpirySummaryModel(res?.data)
  }
